import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { parentFind } from "library/tree/index.mjs"
import { PlanRoot } from "library/tree/constants.mjs"
import { getPlanId } from "routes/plan/controller/use-plan"
import { Secure } from "lib/authorization/secure"
import { Button } from "@mui/material"
import { publishPlan } from "routes/plan/controller/publish-plan"
import { navigate } from "lib/routes/navigate"
import { uniqueId } from "library/database/split-id.mjs"
import { waitForScheduleRefresh } from "routes/schedule/lib/wait-for-schedule-refresh"
import { Frag } from "lib/@components/slot/frag"
import { busyWhile } from "lib/@components/busy/busy-while"
import { useDialog } from "lib/@hooks/useDialog"
import { AuditModal } from "routes/regime/components/audit-modal"
import { Bound } from "lib/@components/binding/Bound"
import { useState } from "react"
import { AuditModalTop } from "slot-definitions"
import { replaceAllWith } from "lib/@components/slot/replace-all-with"
import { FEATURE_FLAG_REGIME_AUDITING } from "routes/regime/plugins/regime-auditing/server/feature-flag-regime-auditing.mjs"
import { isEnabled } from "lib/@components/feature"
import { useIsNextRegimeStepDisabled } from "routes/regime/plugins/publishing/hooks/use-is-next-regime-step-disabled"
import { IfTooltip } from "lib/if-tooltip"

export function CreateDraft() {
    const { parentItem } = useBoundContext()
    const parent = parentFind(parentItem, (c) => c[PlanRoot])
    const id = getPlanId(parent)
    const [revisionSummary] = useState("")

    const { disabled, message } = useIsNextRegimeStepDisabled("Draft")

    AuditModalTop.usePlug(replaceAllWith(<Frag />))

    const reasonsForDraft = useDialog(
        <Bound target={revisionSummary}>
            <AuditModal placeholder="Tell the reviewer what changes you have made and why..." />
        </Bound>
    )

    return (
        <Secure
            hide
            demand="manageRegime"
            fallback={<Frag />}
            justifyContent="center"
            sx={{ flex: 1, display: "flex" }}
        >
            <IfTooltip condition={disabled} title={message}>
                <Button
                    size="small"
                    variant="outlined"
                    color="primary"
                    onClick={publish}
                    sx={{ mt: 1, mx: "auto", display: "block" }}
                    data-cy="publish-draft-to-review-btn"
                    disabled={disabled}
                >
                    Submit for Review
                </Button>
            </IfTooltip>
        </Secure>
    )

    async function publish() {
        if (isEnabled(FEATURE_FLAG_REGIME_AUDITING)) {
            const audit = await reasonsForDraft()
            if (audit) {
                const { revisionSummary } = audit
                const subtitledText = `<strong>Revision Summary:</strong><br/>${revisionSummary}`
                performPublish(subtitledText)
            }
        } else {
            performPublish()
        }

        function performPublish(summary) {
            return busyWhile(
                async () => {
                    await publishPlan(id, "publish", summary)
                    navigate(`/app/review/${uniqueId(id)}`)
                },
                "Publishing To Draft",
                waitForScheduleRefresh
            )
        }
    }
}
